import { Link } from "react-router-dom";
import { Sparkles, Heart, Leaf } from "lucide-react";
import SEO from "@/components/SEO";

export default function About() {
  return (
    <div>
      <SEO title="About Us" description="Nityavastra was born from the belief that everyday clothing and home textiles should carry the soul of Indian craftsmanship. Meet the weavers behind our sarees and bedsheets." />
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.pexels.com/photos/6480707/pexels-photo-6480707.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#1C1917]/60" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-8 text-white">
          <p className="uppercase text-xs tracking-[0.3em] text-[#D4A03A] mb-4">Our Story</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-3xl">
            Where tradition meets everyday.
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-20 md:py-24">
        <p className="text-lg leading-relaxed text-[#1C1917]/85 mb-6">
          Nityavastra began with a simple thought — the fabrics we live in should tell a story. From the six yards of a hand-woven saree that carries a mother's blessing, to the crisp bedsheet that welcomes you home each night, textiles are the quietest storytellers of our lives.
        </p>
        <p className="text-lg leading-relaxed text-[#1C1917]/85 mb-6">
          We work directly with weavers, block printers, and small artisan clusters across India — from Kanjivaram and Banaras to Jaipur and Karur — to bring you pieces that are both timeless and thoughtful. No middlemen. Fair wages. Slow, beautiful craft.
        </p>
        <p className="text-lg leading-relaxed text-[#1C1917]/85">
          Whether it's a festive saree or a soft everyday bedsheet — every piece at Nityavastra is chosen to be worn, used, and loved for a long, long time.
        </p>
      </section>

      <section className="bg-[#F5F5F4] border-y border-[#E7E5E4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20 grid grid-cols-1 md:grid-cols-3 gap-10">
          {[
            {
              icon: Sparkles,
              title: "Handcrafted",
              body: "Each piece is made by skilled artisans, not machines. You'll notice the difference in every thread.",
            },
            {
              icon: Heart,
              title: "Fairly Made",
              body: "We pay our weavers directly and above market rates — because good craft deserves good livelihood.",
            },
            {
              icon: Leaf,
              title: "Slow & Sustainable",
              body: "Natural fibers, low-impact dyes, minimal packaging. Made to last decades, not seasons.",
            },
          ].map((v) => (
            <div key={v.title}>
              <div className="w-12 h-12 rounded-full bg-[#7C1F30] flex items-center justify-center mb-5">
                <v.icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-serif text-xl mb-3">{v.title}</h3>
              <p className="text-sm text-[#1C1917]/75 leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-20 text-center">
        <h2 className="font-serif text-3xl sm:text-4xl mb-6">Ready to bring home a story?</h2>
        <Link
          to="/shop"
          className="inline-block bg-[#7C1F30] hover:bg-[#8D2A3D] text-white px-8 py-4 rounded-full uppercase text-xs tracking-[0.2em] transition-colors"
          data-testid="about-shop-btn"
        >
          Explore the Collection
        </Link>
      </section>
    </div>
  );
}
